var PassengerInformation = Backbone.View.extend({
  /**
   * The internal event listeners for the view.
   */
  events: {
    "field-added": "addPassenger",
    "field-removed": "removePassenger",
    "click [data-remove-passenger-bulk]": "removePassengerBulk"
  },

  /**
   * This method adds a passenger input to the view.
   */
  addPassenger: function() {
    var currentCount = this.$("[data-passenger-container] > [data-traveler]")
      .length;

    // renumber the displayed passengers
    this.renumberPaxSections();

    this.$("[data-add-passenger]").attr(
      "data-duplicator-count",
      currentCount - 1
    );

    this.toggleRequiredAirInputs(this.has_air);

    this.addPassengerCount(currentCount);
  },

  /**
   * This method removes a passenger from the view.
   */
  removePassenger: function() {
    var currentCount = this.$("[data-passenger-container] > [data-traveler]")
      .length;

    this.renumberPaxSections();

    this.$("[data-add-passenger]").attr(
      "data-duplicator-count",
      currentCount - 1
    );

    this.addPassengerCount(currentCount);
  },

  addPassengerCount: function(currentCount) {
    this.$el.removeClass();
    this.$el.addClass("passenger-count-" + currentCount);
  },

  removePassengerBulk: function() {
    this.$("[data-remove-passenger]").each(function(index, el) {
      el.click();
    });
  },

  /**
   * This method renumbers the passenger sections.
   */
  renumberPaxSections: function() {
    var counter = 1;

    this.$('[data-duplicator-name^="passenger-type"]').each(function() {
      $(this).attr("data-duplicator-name", "passenger-type" + counter);
      counter++;
    });

    counter = 1;
    this.$('[data-duplicator-name^="passenger-age"]').each(function() {
      $(this).attr("data-duplicator-name", "passenger-age" + counter);
      counter++;
    });

    counter = 1;
    this.$('[data-duplicator-name^="passenger-airport-residency"]').each(
      function() {
        $(this).attr(
          "data-duplicator-name",
          "passenger-airport-residency" + counter
        );
        counter++;
      }
    );

    counter = 1;
    this.$('[data-duplicator-name^="passenger-residency"]').each(function() {
      $(this).attr("data-duplicator-name", "passenger-residency" + counter);
      counter++;
    });
  },

  toggleRequiredAirInputs: function(has_air) {
    this.has_air = has_air;

    this.$("[data-traveler]").each(function() {
      var Passenger = $(this).component();

      Passenger.toggleRequiredAirInputs(has_air);
    });
  },

  initialize: function() {
    this.$el.loadComponents();
    this.$el.loadModules();
    this.settings = this.$el.data("settings");

    this.has_air = this.settings.has_air;
  }
});

module.exports = PassengerInformation;
